/** @jsxImportSource @emotion/react */
import React, { Component, Fragment } from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';

import Button from '../button/Button';
import Icon from '../icon/Icon';
import Select from './Select';
import Input from './Input';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { minLength3 } from '~APP_UTIL/formValidations';

class StatusSearch extends Component {
  constructor(props) {
    super(props);

    this.state = { searchTerm: '' };
  }

  handleSetSearchTerm = val => {
    const { setSearchTerm } = this.props;

    if (setSearchTerm) setSearchTerm(val);

    this.setState({ searchTerm: val });
  };

  handleSubmit = e => {
    if (e && e.preventDefault) e.preventDefault();
    const { onSubmit } = this.props;
    const { searchTerm } = this.state;

    if (onSubmit) onSubmit(searchTerm);
  };

  handleClear = () => {
    const { name, change, clearSearch } = this.props;
    change(`${name}__input`, '');
    clearSearch();
  };

  render() {
    const { name, searchKeyOptions, setSearchKey } = this.props;

    return (
      <>
        <form
          onSubmit={this.handleSubmit}
          css={css`
            .ncss-input-container {
              min-height: 42px;
              .ncss-input {
                min-height: 42px;
                height: 45px;
              }
              .ncss-input:not(:focus) + label {
                top: 10px;
              }
            }
          `}
        >
          <Field
            label={new TranslatedCopy({ id: 'global.search' }).toString()}
            name={`${name}__input`}
            component={Input}
            onChange={this.handleSetSearchTerm}
            validate={[minLength3]}
          />
          <Button type='button' useBareClass textLink aria-label='clear' className='clear' onClick={this.handleClear}>
            <Icon name='x' alt='clear' />
          </Button>
        </form>
        {searchKeyOptions && (
          <div className='dropdown body-4'>
            <Field
              name={`${name}__searchKey`}
              component={Select}
              options={searchKeyOptions}
              onChange={setSearchKey}
              clearable={false}
              validation={[minLength3]}
            />
          </div>
        )}
        <Button dataDesc={`${name}__button_search`} secondary onClick={this.handleSubmit}>
          <Icon name='search' alt='search' />
        </Button>
      </>
    );
  }
}

StatusSearch.defaultProps = {
  setSearchKey: null,
  onSubmit: null
};

StatusSearch.propTypes = {
  name: PropTypes.string.isRequired,
  onSubmit: PropTypes.func,
  change: PropTypes.func.isRequired,
  clearSearch: PropTypes.func.isRequired,
  searchKeyOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired,
  setSearchKey: PropTypes.func,
  setSearchTerm: PropTypes.func.isRequired
};

export default StatusSearch;
